/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VogMode {
    /**
     * Classic mode, vog channels are opened when needed.
     */ 
    Automatic = 0,
    /**
     * Vog channels are opened by the user.
     */ 
    UserControlled = 1,
}
